import { action } from 'typesafe-actions';
import { ChangeEvent } from 'react';
import { FormApi } from 'final-form';

import { IUploadFile } from 'CorePackage/MainModule/interfaces/IUploadFile';

import { FeedbackActionsEnum } from '../enums/FeedbackActionsEnum';
import { FeedbackFormType } from '../types/FeedbackFormType';
import { IKnmPlan } from '../../../PlanListPackage/MainModule/interfaces/IKnmPlan';
import { IFeedbackKnmData } from '../interfaces/IFeedbackKnmData';

export const feedbackPost = (values: FeedbackFormType, files: IUploadFile[], textDescription: string) =>
  action(FeedbackActionsEnum.FEEDBACK_POST, { values, files, textDescription });
export const feedbackReset = () => action(FeedbackActionsEnum.FEEDBACK_RESET);
export const feedbackSetError = (error: string) => action(FeedbackActionsEnum.FEEDBACK_SET_ERROR, { error });
export const feedbackSetFiles = (files: IUploadFile[]) => action(FeedbackActionsEnum.FEEDBACK_SET_FILES, { files });
export const feedbackUploadFile = (e: ChangeEvent<HTMLInputElement>, nameIfExists?: string) =>
  action(FeedbackActionsEnum.FEEDBACK_UPLOAD_FILE, { e, nameIfExists });
export const feedbackSetForm = (form: FormApi<FeedbackFormType, Partial<FeedbackFormType>>) =>
  action(FeedbackActionsEnum.FEEDBACK_SET_FORM, { form });
export const feedbackSetKnmData = (knmData: IFeedbackKnmData) =>
  action(FeedbackActionsEnum.FEEDBACK_SET_KNM_DATA, { knmData });
export const feedbackSetPlanData = (planData: IKnmPlan) =>
  action(FeedbackActionsEnum.FEEDBACK_SET_PLAN_DATA, { planData });
